var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';
import { TalentAttribute as TalentAttributeEntity, TalentAttributeCategories, } from 'packages/talent/entities/TalentAttribute';
import AttributeLevelsList from 'ui/v1/attributes/AttributeLevelsList.vue';
import { JobAttachedAttribute } from 'packages/talent/entities/JobAttachedAttribute';
import { EntityBuilder } from '@decahedron/entity';
import v4 from 'uuid/v4';
import { Action, Getter } from 'vuex-class';
import UiRichRadioOption from 'ui/v1/controls/UiRichRadioOption.vue';
import Icon from 'common/UIToolKit/Icon.vue';
var JobAttributesEditor = /** @class */ (function (_super) {
    __extends(JobAttributesEditor, _super);
    function JobAttributesEditor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dirty = false;
        _this.newOptions = null;
        _this.newAttribute = new TalentAttributeEntity();
        _this.currentlySelectedCategory = null;
        _this.currentlySelectedAttribute = null;
        _this.currentlySelectedAttributeValue = { isRequired: false, isIdeal: false, disqualifyOnFailure: false };
        _this.isSelectedAttributeValid = true;
        _this.attributeCategories = TalentAttributeCategories;
        _this.modifyingAttribute = false;
        return _this;
    }
    Object.defineProperty(JobAttributesEditor.prototype, "displayRequiredAttributeTypeError", {
        get: function () {
            return !this.isSelectedAttributeValid && this.currentlySelectedAttribute && !this.currentlySelectedAttributeValue.isRequired && !this.currentlySelectedAttributeValue.isIdeal;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JobAttributesEditor.prototype, "displayRequiredAttributeError", {
        get: function () {
            return !this.isSelectedAttributeValid && !this.currentlySelectedAttribute;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JobAttributesEditor.prototype, "displayRequiredValueError", {
        get: function () {
            return !this.isSelectedAttributeValid && this.currentlySelectedAttributeValue.isRequired;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JobAttributesEditor.prototype, "displayIdealValueError", {
        get: function () {
            return !this.isSelectedAttributeValid && this.currentlySelectedAttributeValue.isIdeal;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JobAttributesEditor.prototype, "isNewAttributeNameMissing", {
        // TODO: replace these with JDS-level validators
        get: function () {
            return !this.newAttribute.name || this.newAttribute.name.trim() === '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JobAttributesEditor.prototype, "isNewAttributeNameExists", {
        get: function () {
            var _this = this;
            if (!this.newAttribute.name) {
                return false;
            }
            return this.attributes.find(function (_a) {
                var name = _a.name;
                return name === _this.newAttribute.name.trim();
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JobAttributesEditor.prototype, "checkEmptyNewOptions", {
        get: function () {
            if (this.newAttribute.type !== 'scale') {
                return [];
            }
            return Array.from(this.newOptions)
                .map(function (_a, index) {
                var value = _a[1];
                return [index, value];
            })
                .filter(function (_a) {
                var value = _a[1];
                return value.trim() === '';
            })
                .map(function (_a) {
                var index = _a[0];
                return index;
            });
        },
        enumerable: false,
        configurable: true
    });
    JobAttributesEditor.prototype.getAttributesCategoryDescription = function (category) {
        switch (category) {
            case 'skills':
                return this.$t('attributes.descriptions.skills');
            case 'personality':
                return this.$t('attributes.descriptions.personality');
            case 'education':
                return this.$t('attributes.descriptions.education');
            case 'availability':
            default:
                return this.$t('attributes.descriptions.availability');
        }
    };
    JobAttributesEditor.prototype.getAttributesCategory = function (category) {
        switch (category) {
            case 'skills':
                return this.$t('attributes.categories.skills');
            case 'personality':
                return this.$t('attributes.categories.personality');
            case 'other':
                return this.$t('attributes.categories.other');
            case 'education':
                return this.$t('attributes.categories.education');
            case 'availability':
            default:
                return this.$t('attributes.categories.availability');
        }
    };
    JobAttributesEditor.prototype.mounted = function () {
        if (!this.attributes.some(function (attribute) { return attribute.category === 'other'; })) {
            this.attributeCategories = this.attributeCategories.filter(function (category) { return category !== 'other'; });
        }
    };
    JobAttributesEditor.prototype.updateAttributeType = function (value, type) {
        if (!this.currentlySelectedAttribute) {
            return;
        }
        if (this.currentlySelectedAttribute.type === 'scale' && type === 'isRequired' && value) {
            this.currentlySelectedAttributeValue = __assign(__assign({}, this.currentlySelectedAttributeValue), { isRequired: true });
        }
        else if (this.currentlySelectedAttribute.type === 'scale' && type === 'isRequired' && !value) {
            this.currentlySelectedAttributeValue = __assign(__assign({}, this.currentlySelectedAttributeValue), { isRequired: false, disqualifyOnFailure: false });
        }
        else if (this.currentlySelectedAttribute.type === 'scale' && type === 'isIdeal' && value) {
            this.currentlySelectedAttributeValue = __assign(__assign({}, this.currentlySelectedAttributeValue), { isIdeal: true });
        }
        else if (this.currentlySelectedAttribute.type === 'scale' && type === 'isIdeal' && !value) {
            this.currentlySelectedAttributeValue = __assign(__assign({}, this.currentlySelectedAttributeValue), { isIdeal: false });
        }
        else if (this.currentlySelectedAttribute.type === 'scale' && type === 'disqualifyOnFailure' && value) {
            this.currentlySelectedAttributeValue = __assign(__assign({}, this.currentlySelectedAttributeValue), { disqualifyOnFailure: true, isRequired: true });
        }
        else if (this.currentlySelectedAttribute.type === 'scale' && type === 'disqualifyOnFailure' && !value) {
            this.currentlySelectedAttributeValue = __assign(__assign({}, this.currentlySelectedAttributeValue), { disqualifyOnFailure: false });
        }
        else if (this.currentlySelectedAttribute.type === 'bool' && type === 'isRequired' && value) {
            this.currentlySelectedAttributeValue = __assign(__assign({}, this.currentlySelectedAttributeValue), { isRequired: true, isIdeal: false });
        }
        else if (this.currentlySelectedAttribute.type === 'bool' && type === 'isRequired' && !value) {
            this.currentlySelectedAttributeValue = __assign(__assign({}, this.currentlySelectedAttributeValue), { isRequired: false, disqualifyOnFailure: false });
        }
        else if (this.currentlySelectedAttribute.type === 'bool' && type === 'isIdeal' && value) {
            this.currentlySelectedAttributeValue = __assign(__assign({}, this.currentlySelectedAttributeValue), { isRequired: false, disqualifyOnFailure: false, isIdeal: true });
        }
        else if (this.currentlySelectedAttribute.type === 'bool' && type === 'isIdeal' && !value) {
            this.currentlySelectedAttributeValue = __assign(__assign({}, this.currentlySelectedAttributeValue), { isIdeal: false });
        }
        else if (this.currentlySelectedAttribute.type === 'bool' && type === 'disqualifyOnFailure' && value) {
            this.currentlySelectedAttributeValue = __assign(__assign({}, this.currentlySelectedAttributeValue), { disqualifyOnFailure: true, isRequired: true, isIdeal: false });
        }
        else if (this.currentlySelectedAttribute.type === 'bool' && type === 'disqualifyOnFailure' && !value) {
            this.currentlySelectedAttributeValue = __assign(__assign({}, this.currentlySelectedAttributeValue), { disqualifyOnFailure: false });
        }
    };
    JobAttributesEditor.prototype.openCreator = function (category) {
        var _this = this;
        this.editor.close();
        this.dirty = false;
        this.newAttribute = new TalentAttributeEntity();
        this.newAttribute.type = 'bool';
        this.newAttribute.category = category;
        this.newOptions = new Map([
            [v4(), this.$t('attributes.scales.excellent')],
            [v4(), this.$t('attributes.scales.good')],
            [v4(), this.$t('attributes.scales.average')],
            [v4(), this.$t('attributes.scales.poor')],
        ]);
        setTimeout(function () {
            _this.creator.open();
        }, 100);
    };
    JobAttributesEditor.prototype.create = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.isNewAttributeNameMissing ||
                            this.isNewAttributeNameExists ||
                            this.checkEmptyNewOptions.length > 0) {
                            this.dirty = true;
                            return [2 /*return*/];
                        }
                        this.dirty = false;
                        if (this.newAttribute.type === 'scale') {
                            this.newAttribute.metadata = {
                                options: Array.from(this.newOptions).map(function (_a, position) {
                                    var label = _a[1];
                                    return ({
                                        position: position,
                                        label: label,
                                    });
                                }),
                            };
                        }
                        _a = this;
                        return [4 /*yield*/, this.createAttribute({ attribute: this.newAttribute, companyId: this.currentCompanyId })];
                    case 1:
                        _a.currentlySelectedAttribute = _b.sent();
                        this.resetCreation();
                        this.creator.close();
                        this.editor.open();
                        return [2 /*return*/];
                }
            });
        });
    };
    JobAttributesEditor.prototype.resetCreation = function () {
        this.newOptions = new Map();
    };
    JobAttributesEditor.prototype.openEditor = function (category) {
        this.modifyingAttribute = false;
        this.currentlySelectedAttributeValue = {
            requiredValue: null,
            isRequired: false,
            disqualifyOnFailure: false,
            isIdeal: false,
            idealValue: null,
        };
        this.currentlySelectedAttribute = EntityBuilder.buildOne(TalentAttributeEntity, this.getAvailableAttributesByCategory(category)[0]);
        this.currentlySelectedCategory = category;
        this.editor.open();
    };
    JobAttributesEditor.prototype.modifyAttribute = function (attribute) {
        var _this = this;
        this.currentlySelectedAttributeValue = {
            requiredValue: null,
            isRequired: false,
            disqualifyOnFailure: false,
            isIdeal: false,
            idealValue: null,
        };
        this.modifyingAttribute = true;
        this.currentlySelectedCategory = attribute.category;
        if (attribute.requiredValue !== null) {
            this.currentlySelectedAttributeValue.isRequired = true;
            this.currentlySelectedAttributeValue.requiredValue = attribute.requiredValue;
        }
        if (attribute.idealValue !== null) {
            this.currentlySelectedAttributeValue.isIdeal = true;
            this.currentlySelectedAttributeValue.idealValue = attribute.idealValue;
        }
        this.currentlySelectedAttributeValue.disqualifyOnFailure = attribute.disqualifyOnFailure;
        this.currentlySelectedAttribute = EntityBuilder.buildOne(TalentAttributeEntity, attribute);
        setTimeout(function () {
            _this.editor.open();
        }, 100);
    };
    JobAttributesEditor.prototype.addAttribute = function () {
        this.validateSelectedAttribute();
        if (!this.isSelectedAttributeValid) {
            return;
        }
        this.attachedAttributes.push(EntityBuilder.buildOne(JobAttachedAttribute, __assign(__assign({}, this.currentlySelectedAttribute), this.currentlySelectedAttributeValue)));
        this.$emit('attachedAttributeChanged', this.attachedAttributes);
        this.editor.close();
    };
    JobAttributesEditor.prototype.saveAttribute = function () {
        var _this = this;
        this.validateSelectedAttribute();
        if (!this.isSelectedAttributeValid) {
            return;
        }
        this.attachedAttributes.splice(this.attachedAttributes.findIndex(function (attribute) { return attribute.id === _this.currentlySelectedAttribute.id; }), 1, EntityBuilder.buildOne(JobAttachedAttribute, __assign(__assign({}, this.currentlySelectedAttribute), this.currentlySelectedAttributeValue)));
        this.$emit('attachedAttributeChanged', this.attachedAttributes);
        this.editor.close();
    };
    JobAttributesEditor.prototype.validateSelectedAttribute = function () {
        return this.isSelectedAttributeValid = this.validateAttribute(__assign(__assign({}, this.currentlySelectedAttribute), this.currentlySelectedAttributeValue)) === null;
    };
    JobAttributesEditor.prototype.removeAttribute = function (attribute) {
        this.$emit('attachedAttributeChanged', this.attachedAttributes.filter(function (filteredAttribute) { return filteredAttribute.id !== attribute.id; }));
    };
    JobAttributesEditor.prototype.getAvailableAttributesByCategory = function (category) {
        // @TODO: Add filtering so that already added attributes will be filtered off
        return this.attributes.filter(function (attribute) { return attribute.category === category; });
    };
    JobAttributesEditor.prototype.getAttachedAttributesByCategory = function (category) {
        return Array.from(Object.values(this.attachedAttributes)).filter(function (attribute) { return attribute.category === category; });
    };
    JobAttributesEditor.prototype.validateAttribute = function (attribute) {
        if (attribute.type === 'bool') {
            if (!attribute.isIdeal && !attribute.isRequired) {
                return this.$t('jobs.wizard.errors.attributes.required_value');
            }
            if (attribute.isIdeal && attribute.disqualifyOnFailure) {
                return this.$t('jobs.wizard.errors.attributes.required_value');
            }
            if (!attribute.isRequired && attribute.disqualifyOnFailure) {
                return this.$t('jobs.wizard.errors.attributes.required_value');
            }
            if (attribute.isRequired && attribute.requiredValue === null) {
                return this.$t('jobs.wizard.errors.attributes.required_value');
            }
            if (attribute.isIdeal && attribute.idealValue === null) {
                return this.$t('jobs.wizard.errors.attributes.required_value');
            }
            return null;
        }
        else if (attribute.type === 'scale') {
            if (!attribute.isIdeal && !attribute.isRequired) {
                return this.$t('jobs.wizard.errors.attributes.required_value');
            }
            if (!attribute.isRequired && attribute.disqualifyOnFailure) {
                return this.$t('jobs.wizard.errors.attributes.required_value');
            }
            if (attribute.isRequired && attribute.requiredValue === null) {
                return this.$t('jobs.wizard.errors.attributes.required_value');
            }
            if (attribute.isIdeal && attribute.idealValue === null) {
                return this.$t('jobs.wizard.errors.attributes.required_value');
            }
            return null;
        }
        // Running validation against an unknown type of attribute
        return this.$t('jobs.wizard.errors.attributes.required_value');
    };
    JobAttributesEditor.prototype.resetCreateAttributeModal = function () {
        if (this.currentlySelectedAttribute && !this.modifyingAttribute) {
            this.currentlySelectedAttributeValue = {
                requiredValue: null,
                isRequired: false,
                disqualifyOnFailure: false,
                isIdeal: false,
                idealValue: null,
            };
        }
    };
    JobAttributesEditor.prototype.resetValidation = function () {
        this.isSelectedAttributeValid = true;
    };
    JobAttributesEditor.prototype.setIdealDefaultValue = function (newVal) {
        var _a, _b;
        if (((_a = this.currentlySelectedAttribute) === null || _a === void 0 ? void 0 : _a.type) === 'bool' && newVal && this.currentlySelectedAttributeValue.idealValue === null) {
            this.currentlySelectedAttributeValue.idealValue = 1;
        }
        else if (((_b = this.currentlySelectedAttribute) === null || _b === void 0 ? void 0 : _b.type) === 'scale' && newVal && !this.currentlySelectedAttributeValue.idealValue) {
            this.currentlySelectedAttributeValue.idealValue = this.currentlySelectedAttribute.metadata.options[0].id;
        }
        else if (!newVal) {
            // If ideal is set to false, null the value as well to avoid resetting to default
            this.currentlySelectedAttributeValue.idealValue = null;
        }
    };
    JobAttributesEditor.prototype.setRequiredDefaultValue = function (newVal) {
        var _a, _b;
        if (((_a = this.currentlySelectedAttribute) === null || _a === void 0 ? void 0 : _a.type) === 'bool' && newVal && this.currentlySelectedAttributeValue.requiredValue === null) {
            this.currentlySelectedAttributeValue.requiredValue = 1;
        }
        else if (((_b = this.currentlySelectedAttribute) === null || _b === void 0 ? void 0 : _b.type) === 'scale' && newVal && !this.currentlySelectedAttributeValue.requiredValue) {
            if (this.currentlySelectedAttribute.metadata.options.length > 1) {
                return this.currentlySelectedAttributeValue.requiredValue = this.currentlySelectedAttribute.metadata.options[1].id;
            }
            this.currentlySelectedAttributeValue.requiredValue = this.currentlySelectedAttribute.metadata.options[0].id;
        }
        else if (!newVal) {
            // If required is set to false, null the value as well to avoid resetting to default
            this.currentlySelectedAttributeValue.requiredValue = null;
        }
    };
    JobAttributesEditor.prototype.setDisqualifyingDefaultValue = function (newVal) {
        var _a;
        if (((_a = this.currentlySelectedAttribute) === null || _a === void 0 ? void 0 : _a.type) === 'bool' && newVal) {
            this.currentlySelectedAttributeValue.disqualifyOnFailure = true;
        }
    };
    __decorate([
        Getter,
        __metadata("design:type", Number)
    ], JobAttributesEditor.prototype, "currentCompanyId", void 0);
    __decorate([
        Action,
        __metadata("design:type", Function)
    ], JobAttributesEditor.prototype, "createAttribute", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Array)
    ], JobAttributesEditor.prototype, "attributes", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Array)
    ], JobAttributesEditor.prototype, "attachedAttributes", void 0);
    __decorate([
        Ref(),
        __metadata("design:type", Object)
    ], JobAttributesEditor.prototype, "editor", void 0);
    __decorate([
        Ref(),
        __metadata("design:type", Object)
    ], JobAttributesEditor.prototype, "creator", void 0);
    __decorate([
        Watch('currentlySelectedAttribute'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], JobAttributesEditor.prototype, "resetCreateAttributeModal", null);
    __decorate([
        Watch('currentlySelectedAttribute'),
        Watch('currentlySelectedAttributeValue', { deep: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], JobAttributesEditor.prototype, "resetValidation", null);
    __decorate([
        Watch('currentlySelectedAttributeValue.isIdeal'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], JobAttributesEditor.prototype, "setIdealDefaultValue", null);
    __decorate([
        Watch('currentlySelectedAttributeValue.isRequired'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], JobAttributesEditor.prototype, "setRequiredDefaultValue", null);
    __decorate([
        Watch('currentlySelectedAttributeValue.disqualifyOnFailure'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], JobAttributesEditor.prototype, "setDisqualifyingDefaultValue", null);
    JobAttributesEditor = __decorate([
        Component({
            components: {
                AttributeLevelsList: AttributeLevelsList,
                Icon: Icon,
                UiRichRadioOption: UiRichRadioOption,
            },
        })
    ], JobAttributesEditor);
    return JobAttributesEditor;
}(Vue));
export default JobAttributesEditor;
